import Vue from 'vue';

function getPreviewEl (el) {
    const previewElClass = 'v-md-editor-preview';

    return el.classList.contains(previewElClass) ? el : el.querySelector(`.${previewElClass}`);
}

export default function createChartAiopsPlugin () {
    async function handleMdChange () {
        if (typeof window === 'undefined') return;

        await this.$nextTick();

        const previewEl = getPreviewEl(this.$el);
        const eles = previewEl.querySelectorAll('.v-md-pre-wrapper-gpt-chatbox-opex');
        if (!eles.length) return;

        let ele = eles[0];
        if (!ele || !ele.innerText) return;

        try {
            let text = ele.innerText;
            let data;
            const compName = 'gpt-chart-aiops';
            if (text.indexOf('#report') === 0) {
                const jsonStr = text.replace('#report', '');
                data = JSON.parse(jsonStr);
            }
            if (data && compName) {
                let propsData = { value: data };// 组件初始化时传入绑定数据（propsData只能用于初始化，复发响应式）

                let Comp = Vue.component(compName);
                if (!Comp) {
                    throw new Error(`Component ${compName} not found`);
                }
                let comp = new Comp({ propsData });
                comp.$mount(ele);
            } else {
                ele.innerText = '未识别数据';
            }
        } catch (err) {
            console.error(err);
            ele.innerText = '分析过程中出现错误';
        }
    }

    return {
        install (VMdEditor) {
            if (!VMdEditor.mixins) VMdEditor.mixins = [];

            VMdEditor.mixins.push({
                watch: {
                    value: {
                        immediate: true,
                        handler: handleMdChange
                    },
                    text: {
                        immediate: true,
                        handler: handleMdChange
                    },
                    currentMode: handleMdChange
                }
            });
        }
    };
};
